import { render, staticRenderFns } from "./EventSideMenu.vue?vue&type=template&id=01330d3c&scoped=true"
import script from "./EventSideMenu.vue?vue&type=script&lang=ts"
export * from "./EventSideMenu.vue?vue&type=script&lang=ts"
import style0 from "./EventSideMenu.vue?vue&type=style&index=0&id=01330d3c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01330d3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01330d3c')) {
      api.createRecord('01330d3c', component.options)
    } else {
      api.reload('01330d3c', component.options)
    }
    module.hot.accept("./EventSideMenu.vue?vue&type=template&id=01330d3c&scoped=true", function () {
      api.rerender('01330d3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/EventSideMenu.vue"
export default component.exports